import React, { useState } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import PDFPreviewModal from './PDFPreviewModal';

interface ExportPDFButtonProps {
  profile: any; // Usar any temporalmente para evitar conflictos de tipos
  userId?: string; // UID del usuario para generar el QR correctamente
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

const ExportPDFButton: React.FC<ExportPDFButtonProps> = ({
  profile,
  userId,
  className = '',
  variant = 'primary',
  size = 'md'
}) => {
  const { t, i18n } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-red-600 text-white hover:bg-red-700 border-red-600';
      case 'secondary':
        return 'bg-gray-600 text-white hover:bg-gray-700 border-gray-600';
      case 'outline':
        return 'bg-white text-red-600 border-2 border-red-600 hover:bg-red-50';
      default:
        return 'bg-red-600 text-white hover:bg-red-700 border-red-600';
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-3 py-1.5 text-sm';
      case 'md':
        return 'px-4 py-2 text-sm';
      case 'lg':
        return 'px-6 py-3 text-base';
      default:
        return 'px-4 py-2 text-sm';
    }
  };

  return (
    <>
      <button
        onClick={handleOpenModal}
        className={`
          flex items-center gap-2 rounded-lg font-medium transition-colors
          ${getVariantClasses()}
          ${getSizeClasses()}
          ${className}
        `}
        title={t('profile.viewPDF')}
      >
        <FaFilePdf className={size === 'sm' ? 'text-xs' : 'text-sm'} />
        <span>{t('profile.viewPDF')}</span>
      </button>

      <PDFPreviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        profile={profile}
        userId={userId}
        language={i18n.language as 'es' | 'en'}
      />
    </>
  );
};

export default ExportPDFButton; 